<template>
  <div class="modal">
    <div>
      <div class="modal-content">
        <div class="modal-colse" @click="childModalClose">
          <img src="" alt="" />
        </div>
        <div class="modal-nav">
          {{ tplData.title }}
        </div>
        <div id="makeMail">
          <div class="en" style="">
            <div
              class="emailHead"
              style="padding: 0px 0px 16px 0px;"
              v-if="tplData.content.en.header != ''"
            >
              {{ tplData.content.en.header }}
            </div>
            <div
              class="emailContent"
              style="text-indent:30px"
              v-html="showHtml(tplData.content.en.mainContent)"
            ></div>
            <div
              class="emailFoot"
              style="    padding: 16px 0px;"
              v-if="tplData.content.en.header != ''"
            >
              {{ tplData.content.en.footer }}
            </div>
          </div>
          <div
            class="zh"
            style="background:#EFEFEF;padding: 30px;border-radius: 5px;margin-top: 20px;"
          >
            <div
              class="emailHead"
              style="padding: 16px 0px;"
              v-if="tplData.content.zh.header != ''"
            >
              {{ tplData.content.zh.header }}
            </div>
            <div
              class="emailContent"
              style=""
              v-html="showHtml(tplData.content.zh.mainContent)"
            ></div>
            <div
              class="emailFoot"
              style="padding: 16px 0px;"
              v-if="tplData.content.zh.header != ''"
            >
              {{ tplData.content.zh.footer }}
            </div>
          </div>
          <div style="text-align:center;padding:20px">
            <el-button type="success" @click="sendTpl">发送模板</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      username: "",
      email: "",
      options: [
        {
          value: "Hotmail 通道",
          label: "Hotmail 通道",
        },
        {
          value: "Gmail 通道",
          label: "Gmail 通道",
        },
        {
          value: "Outlook 通道",
          label: "Outlook 通道",
        },
      ],
      value: "",
    };
  },
  props: ["tplData"],
  methods: {
    // 关闭模态框,发送childModalClose事件
    childModalClose() {
      this.$emit("childModalClose", false);
    },
    sendTpl() {
      this.$emit("sendTpl", this.tplData);
    },
    showHtml(content) {
      if (!content) return;
      let html = content.replace(/\n/g, "<br>&nbsp;&nbsp;&nbsp;&nbsp;");
      return html;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 100px 0;
  z-index: 1000;
  min-width: 1366px;
  div.modal-content {
    background-color: #ffffff;
    position: relative;
    margin-bottom: 50px;
    box-shadow: 0px 0px 10px rgb(102, 102, 102);
    border-radius: 2px;
    @media screen and (max-width: 1440px) {
      width: 60%;
      margin: 0 auto;
    }
    @media screen and (min-width: 1440px) {
      width: 60%;
      margin: 0 auto;
    }
    div.modal-colse {
      width: 29px;
      height: 29px;
      border-radius: 50%;
      position: absolute;
      right: -14.5px;
      top: -14.5px;
      z-index: 100;
      cursor: pointer;
    }
    div.modal-main {
    }
  }
}

.modal-nav {
  height: 50px;
  font-family: "Microsoft YaHei";
  position: relative;
  display: flex;
  align-items: center;
  color: #00306b;
  padding: 0px 20px 0px 20px;
  font-size: 14px;
  & > div {
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 15px;
      height: 15px;
      margin-left: 5px;
    }
    span {
      margin: 0 5px;
    }
  }
  &:before {
    content: "";
    width: 5px;
    height: 24px;
    position: absolute;
    bottom: 13px;
    left: 0px;
    border-radius: 0px 10px 10px 0px;
    background: #fda822;
  }
  &:after {
    content: "";
    border-top: 1px dashed #acacac;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 1px;
    z-index: 9;
  }
}

.modal-btn {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 30px 0 36px;
  cursor: pointer;
  div {
    width: 90px;
    height: 30px;
    border: 1px solid;
    border-radius: 3px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    &.modal-btn-2 {
      background-color: #ffffff;
      border-color: #88a5be;
      color: #000000;
    }
    &.modal-btn-3 {
      background-color: #ffa724;
      border-color: #fe9200;
      color: #ffffff;
      margin-right: 20px;
    }
  }
}

#makeMail {
  padding: 42px 35px 30px 35px;
  font-size: 14px;
  line-height: 30px;
}
</style>
